import { UpdateDoctor } from 'domain/usecases/doctor/update-doctor'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteUpdateDoctor implements UpdateDoctor {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  update(params: UpdateDoctor.Params): Promise<UpdateDoctor.Model> {
    return this.doctorRepository.updateDoctor(params)
  }
}

export type UpdateDoctorModel = UpdateDoctor.Model
